<template>
  <div class="employer-card">

    <div class="employer-card__header">

      <div class="employer-card__header-group">

        <div class="employer-card-logo-group">
          <div class="employer-card-logo-container">
            <img class="employer-card-logo" :src="$filters.analyseImage(computedPayload['org-logo'],'logosm','logoxl')" :alt="computedPayload['org-name']" width="64" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'">
          </div>
          <h4 class="employer-card-name">{{ computedPayload['org-name'] }}</h4>
        </div>

        <div class="employer-card__header-btns-container">
          <block-follow-organisation-button v-if="me" class="btn-blue-light" :org_main_id="computedPayload['org-main-id']" :org_name="computedPayload['org-name']"></block-follow-organisation-button>
          <a class="btn-link" :href="`/organisation/redirect/${computedPayload['org-main-id']}`">View Profile</a>
        </div>

        <p class="employer-card-description">{{ computedPayload['org-summary'] }}</p>

      </div>

      <ul class="employer-card-overview">
        <li v-if="computedPayload['org-rating'] && computedPayload['review-count']">
          <div class="employer-card-icon">
            <svg class="icon" width="22" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.422 6.719L8.75 3.594 10.703 0l3.516 6.172 4.453.547 2.734.312-5.547 5.86 1.954 7.03-3.75-2.421-3.282-2.266-5.937 4.297L3.516 20l1.796-7.5L0 6.953l3.047-.312 4.375.078z" fill="#F9AE13"/></svg>
          </div>
          <div class="employer-card-desc">
            <p><strong>{{ $filters.toFixed(computedPayload['org-rating']) }}</strong> from <strong>{{ computedPayload['review-count'] }}</strong> reviews</p>
          </div>
        </li>
        <li v-if="computedPayload['option-industry'] && computedPayload['option-industry'].length">
          <div class="employer-card-icon">
            <img class="icon" :src="`/images/icons/organisation/industry.svg?${$config.version}`" alt="Industry" loading="lazy">
          </div>
          <div class="employer-card-desc">
            <p>{{ computedPayload['option-industry'][0] }}</p>
          </div>
        </li>
        <li v-if="computedPayload['org-live-jobs-count'] && computedPayload['org-live-jobs-count'] > 0">
          <div class="employer-card-icon">
            <svg class="icon" width="22" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#F3EBEA" d="m20.397 3.67-4.654.052c-.994-4.08-5.44-3.714-5.44-3.714-2.929.105-4.08 2.406-4.498 3.818L1.308 3.67h-.21C.732 3.67 0 3.774 0 4.454v12.5l.366.68.785.314L2.354 18l9.048-.052h8.42l1.203-.262.523-.837V4.611c-.052 0-.314-.941-1.15-.941ZM10.67 1.89c1.726-.209 2.72.89 3.243 1.83l-5.962.053c.993-1.987 2.72-1.883 2.72-1.883Zm1.622 7.113c-.366.576-2.563.68-2.772 0-.21-.68-1.099-1.987 1.464-2.667l1.203.837s.418 1.255.105 1.83Zm7.479 2.825-5.178 1.045-7.218.053-5.177-1.15-.576-.367.157-1.046.47-.261 6.016 1.15h6.642l4.34-1.046.785.21v1.202l-.261.21Z"/></svg>
          </div>
          <div class="employer-card-desc">
            <a :href="`/search/jobs?q=query%253D${computedPayload['org-name']}`"><p><strong>{{ computedPayload['org-live-jobs-count'] }}</strong> live jobs</p></a>
          </div>
        </li>
        <li v-if="computedPayload['org-employee-count'] && computedPayload['org-employee-count'] > 0">
          <div class="employer-card-icon">
            <svg class="icon" width="22" height="13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.698 6.487c.772-.359 1.545-1.077 1.85-2.457 0 0 .882-3.56-2.982-4.03h-.193c-.746 0-3.285.22-3.644 3.202 0 0 .193 2.733 2.098 3.478-.856.248-1.794.497-2.374 1.187-.138.166-.939 1.408-1.021 1.601-.276.635-.58 1.684-.608 3.147h.36l8.06.083h1.573c-.028-1.601-.304-2.733-.525-3.34-.552-.884-1.49-2.485-2.594-2.871zM4.886 8.06c.635-.276 1.408-.883 1.656-1.932 0 0 .69-2.65-2.512-2.926h-.166c-.607 0-2.29.193-2.539 2.402 0 0 0 2.015 1.573 2.539C1.822 8.447.47 9.413.331 10.627L0 12.367l.248.22 4.776.028c.027-.58.22-2.402.966-3.7-.442-.413-.994-.772-1.104-.855z" fill="#2D7EAA"/><path d="M22 12.45l-.386-1.823c-.138-1.214-1.408-2.18-2.512-2.484 1.573-.524 1.573-2.457 1.573-2.457-.248-2.208-1.932-2.401-2.54-2.401h-.165c-3.202.276-2.512 2.926-2.512 2.926.22 1.021.856 1.573 1.49 1.85-.082.027-.69.358-1.242.8.773 1.352.8 3.312.8 3.837l5.246-.028.248-.22z" fill="#2D7EAA"/></svg>
          </div>
          <div class="employer-card-desc">
            <p><strong>{{ computedPayload['org-employee-count'] }}</strong> employees</p>
          </div>
        </li>
      </ul>

      <div class="employer-card-btns-container">
        <block-follow-organisation-button v-if="me" class="btn-blue-light btn-medium" :org_main_id="computedPayload['org-main-id']" :org_name="computedPayload['org-name']"></block-follow-organisation-button>
        <a class="btn-link" :href="`/organisation/redirect/${computedPayload['org-main-id']}`">View Profile</a>
      </div>
    </div>


    <div class="employer-card__footer" v-if="computedPayload['org-benefits'] && computedPayload['org-benefits'].length">
      <div class="employer-card__footer-btn" @click="doToggle">
        <h4 class="employer-card__footer-btn-title">Benefits</h4>
        <svg-arrow-down :class="{'active':isOpen}"></svg-arrow-down>
      </div>

      <transition name="slide">
        <div class="employer-card__footer-panel" v-if="isOpen">
          <ul class="employer-card__footer-perks" v-if="computedPayload['org-benefits']">
            <li v-for="(benefits,b) in computedPayload['org-benefits']" :key="b">
              <div class="perks-icon-container">
                <svg class="perks-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#F9AE13">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
              </div>
              <p class="perks-text">{{ benefits }}</p>
            </li>
          </ul>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import AuthMixins from '@/mixins/AuthMixins';

export default {
	name: 'EmployerCard',

  mixins: [AuthMixins],

  props: {
    payload: {
      type: String
    },
  },

  data() {
    return {
      isOpen: false
    }
  },

	mounted() {
    // console.log('EmployerCard:', this.computedPayload);
	},

  methods: {
    doToggle() {
      this.isOpen = !this.isOpen;
    }
  },

  computed: {
		computedPayload() {
      return typeof this.payload === 'string' ? JSON.parse(this.payload) : this.payload;
    },
  }
}
</script>
